import { Box, Title } from "@mantine/core";
import type { JSX } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { useQuery } from "urql";
import Loading from "../../Loading";
import { type AiPersonalityQuery, type AiPersonalityQueryVariables, aiPersonalityQuery } from "./queries";
import Tune from "./Tune";

function TuneLoader(): JSX.Element {
    const { aiPersonalityId } = useParams();
    const [result] = useQuery<AiPersonalityQuery, AiPersonalityQueryVariables>({
        query: aiPersonalityQuery,
        variables: {
            aiPersonalityId: Number.parseInt(aiPersonalityId!, 10),
        },
    });

    let main = null;
    if (result.fetching) {
        main = <Loading />;
    } else if (result.error) {
        main = <Box>Error: {result.error.message}</Box>;
    } else {
        const aiPersonality = result.data?.aiPersonality;
        if (!aiPersonality) {
            main = <Box>AI personality not found</Box>;
        } else {
            main = <Tune aiPersonality={aiPersonality} />;
        }
    }

    return (
        <Box>
            <Title order={2}>Tune AI personality</Title>
            {main}
            <p>
                <Link to="..">Back</Link>
            </p>
        </Box>
    );
}

export default TuneLoader;
